import { type FC } from 'react';

type DownloadButtonProps = {
  filename: string;
  title: string;
};

declare global {
  interface Window {
    posthog?: {
      capture: (event: string, properties?: Record<string, any>) => void;
    };
  }
}

const DownloadButton: FC<DownloadButtonProps> = ({ filename, title }) => {
  const handleDownload = () => {
    try {
      // Track the download event with PostHog
      window.posthog?.capture('mockup_downloaded', {
        filename,
        title,
        source: window.location.pathname,
      });
    } catch (error) {
      console.error('Failed to capture download event:', error);
    }

    const fileUrl = `https://minimalmockups.nyc3.cdn.digitaloceanspaces.com/resources/${filename}`;
    window.location.href = fileUrl;
  };

  return (
    <button
      className="w-full rounded-md bg-neutral-100 p-6 font-medium text-black transition-colors hover:bg-neutral-200"
      onClick={handleDownload}
      type="button"
      aria-label={`Download ${filename}`}
    >
      Download Mockup
    </button>
  );
};

export default DownloadButton;
